import React from "react";
import logger from "utils/logger";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    logger.error("ErrorBoundary caught:", error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  handleGoBack = () => {
    this.setState({ hasError: false, error: null });
    window.history.back();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            padding: "24px",
            textAlign: "center",
            fontFamily: "Inter, system-ui, sans-serif",
          }}
        >
          <div style={{ fontSize: "48px", marginBottom: "16px" }}>!</div>
          <h2 style={{ fontSize: "20px", fontWeight: 600, marginBottom: "8px" }}>
            Something went wrong
          </h2>
          <p
            style={{ fontSize: "14px", color: "#666", marginBottom: "24px" }}
          >
            An unexpected error occurred. Please try again.
          </p>
          <div style={{ display: "flex", gap: "12px" }}>
            <button
              onClick={this.handleGoBack}
              style={{
                padding: "10px 20px",
                fontSize: "14px",
                borderRadius: "8px",
                border: "1px solid #d0d0d0",
                background: "white",
                cursor: "pointer",
              }}
            >
              Go Back
            </button>
            <button
              onClick={this.handleRetry}
              style={{
                padding: "10px 20px",
                fontSize: "14px",
                borderRadius: "8px",
                border: "none",
                background: "#7c3aed",
                color: "white",
                cursor: "pointer",
              }}
            >
              Try Again
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
